import { NavLink } from "react-router-dom";
import ArticlePage from "./ArticlePage";
import { links, pages, navLinks } from "../data/site";
import {
  breadcrumbSchema,
  buildGraph,
  webpageSchema,
} from "../data/schema";

const YoutubePage = () => {
  const seo = pages.youtube;
  const schema = buildGraph([
    webpageSchema(seo),
    breadcrumbSchema([
      { name: "Home", path: "/" },
      { name: "YouTube", path: seo.path },
    ]),
  ]);

  return (
    <ArticlePage
      seo={seo}
      schema={schema}
      theme="dark"
      bigTitle="TUBE"
      heading="Hareesh Rajendran YouTube"
      related={navLinks.filter((link) => link.to !== seo.path)}
    >
      <p>
        Hareesh Rajendran is a full-time Tamil technology YouTuber with 123K
        subscribers.
      </p>
      <p>
        The channel teaches software engineering in Tamil, with a current focus
        on System Design, AI Agents and Agentic AI. It also covers DSA,
        interview preparation, career guidance, developer tools and technology.
      </p>
      <p>
        YouTube is the top of the funnel for{" "}
        <NavLink to="/vanakkam-dsa">Vanakkam DSA</NavLink> and the public home
        for Hareesh Rajendran&apos;s teaching work.
      </p>
      <p>
        Watch on YouTube:{" "}
        <a
          href={links.youtube}
          target="_blank"
          rel="noopener noreferrer me"
        >
          youtube.com/@hareeshrajendran
        </a>
      </p>
      <p>Brand collaborations include Wispr Flow and Discovr AI.</p>
    </ArticlePage>
  );
};

export default YoutubePage;
